export default __webpack_public_path__ + "static/media/home-shop-modern-banner-1.34414f23.jpg";